import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styles from "../../styles/Building MGMT/ImageStack.module.css";

const ImageStack = ({ images, onOrderChange, onImageClick }) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const newOrder = Array.from(images);
    const [moved] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, moved);
    onOrderChange(newOrder);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="imageStack" direction="horizontal">
        {(provided) => (
          <div
            className={styles.stackContainer}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {images?.map((img, index) => (
              <Draggable key={String(img.id)} draggableId={String(img.id)} index={index}>
                {(provided, snapshot) => (
                  <div
                    className={styles.imageCard}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <img
                      src={img.src}
                      alt={`img-${index}`}
                      onClick={() => onImageClick && onImageClick(index)}
                    />
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ImageStack;
